import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { motion } from 'framer-motion';
import { RecordVoiceOver as SpeakingIcon } from '@mui/icons-material';

const MotionCard = motion.create(Card);

interface SpeakingEngagement {
  title: string;
  description: string;
  year: string;
  isCurrent?: boolean;
}

const engagements: SpeakingEngagement[] = [
  {
    title: 'Speaker on Generative AI, machine learning, data integration and RAG applications',
    description: '',
    year: '2023 - Present',
  },
  {
    title: 'Actively engaged in diverse speaking roles at strategic planning sessions and board meetings',
    description: '',
    year: '2013 - Present',
  },
  {
    title: 'Speaker at Lunch & Learn',
    description: 'Business Continuity Planning and Disaster Recovery',
    year: '2010',
  },
  {
    title: 'Speaker for Microsoft at Database User Group',
    description: 'Data Security',
    year: '2009',
  },
  {
    title: 'Speaker for Microsoft at Developer Days Event',
    description: '',
    year: '2001',
  },
];

const Speaking = () => {
  return (
    <Box sx={{ py: { xs: 2, md: 4 } }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Speaking Engagements
      </Typography>
      
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        {engagements.map((engagement, index) => (
          <MotionCard
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            sx={{
              mb: 2,
              backgroundColor: 'background.paper',
              borderRadius: 2,
              borderLeft: engagement.isCurrent ? '4px solid' : 'none',
              borderColor: 'primary.main',
            }}
          >
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <SpeakingIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6" component="h2">
                  {engagement.title}
                </Typography>
              </Box>
              <Typography variant="body1" color="text.secondary" paragraph>
                {engagement.description}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                {engagement.year}
              </Typography>
            </CardContent>
          </MotionCard>
        ))}
      </Box>
    </Box>
  );
};

export default Speaking; 